import React, { FC } from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import { TextField } from "@mui/material";
import { t } from "i18next";

import { OrganizationSettingsFormValues } from "../../OrganizationSettings.types";

import { useGetCurrencies } from "@api";
import { MenuItem } from "@components/base";
import { useUserStore } from "@store/user";

interface CurrencySettings {
  form: UseFormReturn<OrganizationSettingsFormValues>;
}

const CurrencySettings: FC<CurrencySettings> = ({ form: { control } }) => {
  const { user } = useUserStore();
  const { currencies, currenciesEnabled } = useGetCurrencies(user);

  return (
    currenciesEnabled && (
      <Controller
        control={control}
        name="currency"
        rules={{ required: t("validations.currencyIsRequired") }}
        render={({
          field: { onBlur, onChange, name, value },
          fieldState: { error },
        }): React.ReactElement => (
          <TextField
            select
            {...{ onBlur, onChange, name, value }}
            label={t("common.currency")}
            variant="outlined"
            helperText={error?.message}
            error={Boolean(error)}
            sx={{
              width: 260,
            }}
          >
            {currencies?.map((currency) => {
              return (
                <MenuItem key={currency.id} value={currency.id}>
                  {currency.alphabeticCode}
                </MenuItem>
              );
            })}
          </TextField>
        )}
      />
    )
  );
};

export default CurrencySettings;
